import VacancyResult from './VacancyResult';

export default VacancyResult;
